import React from 'react';
import { Span } from './styles';

/* o componente foi criado para melhorar a acessibilidade na aplicação, ele é um elemento span com estilos para ficar invisível
 visualmente e que apenas o leitor de tela leia quando passar por cima do elemento. Com isso ele serve para adicionar textos para 
 melhor leitura, isso ajuda pessoas com deficências visuais a entender melhor o que está ocorrendo na aplicação. */

export interface Props {
  children?: React.ReactNode;
}

const VisuallyHidden = ({ children }: Props) => {
  return <Span>{children}</Span>;
};
export default VisuallyHidden;
